module.exports = __webpack_public_path__ + "static/media/9_I wish you enough_ES.4470f1c6.txt";